import { Link } from "react-router";
import styles from "./Page.module.css";

export function TermsPage() {
  return (
    <article className={styles.page}>
      <h1 className={styles.title}>Terms of use</h1>
      <p className={styles.muted}>Last updated November 3, 2026</p>
      <p>
        This is a personal, private deployment of a time-tracking app. Access is by invitation of its operator. It is
        not affiliated with Clockify or CAKE.com.
      </p>
      <h2 className={styles.subtitle}>Use</h2>
      <p>
        Use it to track your own time and your team's time. Do not try to break, overload or access accounts that are
        not yours.
      </p>
      <h2 className={styles.subtitle}>No warranty</h2>
      <p>
        The service is provided as is, without any warranty or uptime guarantee. Keep your own exports of anything you
        cannot afford to lose.
      </p>
      <h2 className={styles.subtitle}>Your data</h2>
      <p>
        Your data stays yours. No data is sold. Google sign-in is used only for authentication. See the{" "}
        <Link to="/privacy">privacy policy</Link>.
      </p>
      <nav className={styles.footer}>
        <Link to="/">Home</Link>
        <Link to="/privacy">Privacy</Link>
      </nav>
    </article>
  );
}
